import React, { useState, useEffect } from "react";
import axios from "axios";
import Window from "../../../../elements/window";
import Loader from "../../../../../settings/loader";
import Slide1 from "./slides/slide1";
import { useAppContext } from "../../../../../../AppContext";

function GroupBySales({ filter }) {
  const { user, chimeraserv } = useAppContext();
  const props = { user, chimeraserv, filter };
  const [data, setData] = useState({
    sales: {
      data: [],
      state: false,
    },
    currency: {
      base: {},
      state: false,
    },
    state: false,
  });
  const [load, setLoad] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      if (props.user && props.user.data) {
        const headers = {
          Authorization: props.user.data.usrKey,
          "Content-Type": "application/json",
          Accept: "application/json",
        };

        // Fetch sales data
        try {
          const response = await axios.post(
            props.chimeraserv.urlGet + "/sales/set/0/",
            { id: props.filter.base64 },
            { headers }
          );
          setData((prev) => ({
            ...prev,
            sales: {
              data: response.data,
              state: true,
            },
          }));
        } catch (error) {
          setData((prev) => ({
            ...prev,
            sales: {
              data: [],
              state: true,
            },
          }));
        }

        // Fetch currency data
        try {
          const response = await axios.get(
            props.chimeraserv.urlGet + "/group",
            { headers }
          );
          let groupData = [];
          if (Object.keys(response.data).length) {
            groupData = response.data;
          }
          const array = [];
          const currency = groupData
            .map((group) => group.baseCurr)
            .filter((currency) => {
              if (!array.includes(currency)) {
                array.push(currency);
                return true;
              }
              return false;
            });
          setData((prev) => ({
            ...prev,
            currency: {
              base: currency[0] ? currency[0]?.toUpperCase() : "QAR",
              state: true,
            },
          }));
        } catch (error) {
          setData((prev) => ({
            ...prev,
            currency: {
              base: "QAR",
              state: true,
            },
          }));
        }
      }
    };

    fetchData();
    // eslint-disable-next-line
  }, [props.user, props.chimeraserv.urlGet, props.filter.base64]);

  useEffect(() => {
    if (data.currency.state && data.sales.state && !load) {
      setData((prev) => ({
        ...prev,
        state: true,
      }));
      setLoad(1);
    }
    // eslint-disable-next-line
  }, [data.currency.state, data.sales.state, load]);

  return (
    <section>
      {!load ? (
        <Loader />
      ) : (
        <div>
          <Window
            user={props.user}
            chimeraserv={props.chimeraserv}
            title={"Sales by Checks"}
          >
            <Slide1
              {...data}
              {...props}
              user={props.user}
              chimeraserv={props.chimeraserv}
              filter={props.filter}
              data={data}
            />
          </Window>
        </div>
      )}
    </section>
  );
}

export default GroupBySales;
